import React, { useContext, useEffect, useState } from 'react'
import { chatbotStatus, organizationUserDataModel, updateUserStatusPayload } from '../../../models/axiosModel';
import styles from '../../../assets/styles/componentStyles/dataconnectorform.module.scss'
import globalStyles from "../../../assets/styles/global.module.scss";
import connectorstyle from '../../../assets/styles/componentStyles/dataconnector.module.scss'
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import Required from '../../utility/required';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import GlobalButton from '../../utility/globalButton/button';
import { GENERIC_STATUS } from '../../../utils/constants';
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface UpdateStatusPopupProps {
    selectedUser: organizationUserDataModel | null,
    onCloseOfUpdateStatusPopup: () => void,
} 

const UpdateStatusPopup: React.FC<UpdateStatusPopupProps> = (props) => {
    
    const { selectedUser, onCloseOfUpdateStatusPopup } = props;
    const {  setFlagLoading, handleError, GetOrganizationDetails } = useContext(UserContext) as UserContextPayload;

    const { showSuccess, getChatbotStatus, listOfChatbotStatus } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        getChatbotStatus: state.getChatbotStatus,
        listOfChatbotStatus: state.listOfChatbotStatus,
    })))

    const [statusId, setStatusId] = useState<number | null>(Number(selectedUser?.user_organization_status_id) ?? null);

    const getStatusApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getChatbotStatus(); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!listOfChatbotStatus){
            getStatusApiCall();
        }
    }, [])

    const getSelectedUserName = () => {
        let userName = '';
        if(selectedUser){
            if(selectedUser?.private_user_first_name || selectedUser?.private_user_last_name){
                userName = `${selectedUser?.private_user_first_name} ${selectedUser?.private_user_last_name}`;
            } else {
               userName = selectedUser?.private_user_email; 
            }
        }

        if(userName){
            return `for - ${userName}`;
        }
    }

    const getStatusOptions = () => {
        if(listOfChatbotStatus){
            return listOfChatbotStatus?.filter((status) => status?.status_name === GENERIC_STATUS['ACTIVE'] || status?.status_name === GENERIC_STATUS['INACTIVE']);
        }
        return [];
    }

    const getValueOfStatus = () => {
        return listOfChatbotStatus?.find((status) => status?.status_id == statusId) ?? null;
    }

    const onClickOfSaveBtn = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: updateUserStatusPayload = {
            user_assignment_id: selectedUser?.user_assignment_id ?? 0,
            status_id: statusId ?? 0
        }
        const res = await agent.updateUserStatus.put(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess('User Status Updated Successfully')
            GetOrganizationDetails();
        }
        onCloseOfUpdateStatusPopup()
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    return (
        <>

        <Grid container>
                <Grid xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={contactStyles.popupTitleTypography}>
                                {`Update Status ${getSelectedUserName()}`}
                            </Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={contactStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>
                                                Status <Required />
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                options={getStatusOptions()}
                                                getOptionLabel={(option: chatbotStatus) => option.status_name || ''}
                                                value={getValueOfStatus()}
                                                onChange={(_, value: chatbotStatus | null) => setStatusId(value ? value?.status_id : null)}
                                                renderInput={(params) => <TextField {...params} placeholder="Select Status" />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => onCloseOfUpdateStatusPopup()}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Save"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        disabled={!statusId}
                                        onClick={() => onClickOfSaveBtn()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>  
    )
}

export default UpdateStatusPopup
